import { render, staticRenderFns } from "./icon-doc.vue?vue&type=template&id=1288e156&"
import script from "./icon-doc.vue?vue&type=script&lang=js&"
export * from "./icon-doc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports